<template>
  <div>
    <div class="text-right mb-1">
      <b-button
        variant="outline-primary"
        pill
        @click="createBuilding"
        v-if="hasPermission('create_building')"
      >
        <feather-icon icon="PlusIcon" class="mr-50" />
        <span class="align-middle">Add New Building</span>        
      </b-button>
    </div>

    <b-row class="d-flex justify-content-between m-1">
      <b-col md="" class="rounded mr-1 p-2" style="background-color: white;">
        <b-row class="d-flex align-items-center">
          <b-col md="8">
            <h2 class="py-1 text-dark font-weight-bolder">Total Sites</h2>            
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder">Sites</h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ counts.sites }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder">Buildings</h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ counts.buildings }}</h5>
              </b-col>
            </b-row>
          </b-col>
          <b-col md="4">
            <h2 class="py-1 text-dark font-weight-bolder">
              <b-img
                src="@/assets/images/dashboard/site.svg"
                class="img-fluid"
                width="100"
              />
            </h2>
          </b-col>
        </b-row>
      </b-col>

      <b-col md="" class="rounded mr-1 p-2" style="background-color: white;">
        <b-row class="d-flex align-items-center">
          <b-col md="8">
            <h2 class="py-1 text-dark font-weight-bolder">Total Occupants</h2>
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder">Residents</h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ counts.resident }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder">Contractors</h5>
              </b-col>
              <b-col md="4">
                <h5 class="text-dark font-weight-bold">{{ counts.visitor }}</h5>
              </b-col>
            </b-row>            
          </b-col>
          <b-col md="4">
            <h2 class="py-1 text-dark font-weight-bolder">
              <b-img
                src="@/assets/images/dashboard/resident.svg"
                class="img-fluid"
                width="100"
              />
            </h2>
          </b-col>
        </b-row>
      </b-col>

      <b-col md="" class="rounded mr-1 p-2" style="background-color: white;">
        <b-row class="d-flex align-items-center">
          <b-col md="8">
            <h2 class="py-1 text-dark font-weight-bolder">Total PEEPs</h2>
            <b-row>
              <b-col md="9" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder">Permanent PEEPs</h5>
              </b-col>
              <b-col md="3">
                <h5 class="text-dark font-weight-bold">{{ counts.perm_peeps_count }}</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="9" class="d-flex justify-content-start">
                <h5 class="text-dark font-weight-bolder">Temporary PEEPs</h5>
              </b-col>
              <b-col md="3">
                <h5 class="text-dark font-weight-bold">{{ counts.temp_peeps_count }}</h5>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="4" class="text-center">
            <h2 class="py-1 text-dark font-weight-bolder">
              <b-img
                src="@/assets/images/dashboard/peep.svg"
                class="img-fluid"
                width="100"
              />
            </h2>
          </b-col>
        </b-row>
      </b-col>
    </b-row>


    <b-card class="mt-3">
      <b-row class="mb-1" align-v="center">
        <b-col md="7">
          <div v-if="searchType">
            <b-form-group
              label="Site"
              label-for="name"
              class="w-50"
              v-if="searchType.value === 1"
            >
              <b-input-group>
                <template #prepend> </template>
              </b-input-group>
              <v-select
                label="name"
                v-model="site"
                placeholder="Select Site"
                :options="sites"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>

            <b-form-group
              label="Building Type"
              label-for="building_type"
              class="w-50"
              v-if="searchType.value === 2"
            >
              <v-select
                label="name"
                v-model="building_type"
                placeholder="Select Building Type"
                :options="building_types"
                autoscroll
                :clearable="true"
              ></v-select>
            </b-form-group>
          </div>
        </b-col>
        <b-col md="3">
          <b-form-group label="Search Type" label-for="searchType">
            <v-select
              id="searchType"
              v-model="searchType"
              :options="searchTypes"
              placeholder="Search Type"
              label="name"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-button variant="primary" pill @click="search">
            <feather-icon icon="SearchIcon" class="mr-50" />
            <span class="align-middle">Search</span>
          </b-button>
        </b-col>
      </b-row>
      <b-table
        responsive="sm"
        :fields="fields"
        :items="buildings"
        details-td-class="m-0 p-0"
        small
        v-if="hasPermission('read_building')"
        :per-page="0"
      >
        <template #cell(site_data)="row">
          {{
            row.item.site_data ? row.item.site_data.name : ""
          }}
        </template>

        <template #cell(city_data)="row">
          {{
            row.item.city_data ? row.item.city_data.name : ""
          }}
        </template>

        <template #cell(sub_state_data)="row">
          {{
            row.item.sub_state_data ? row.item.sub_state_data.name : ""
          }}
        </template>
        
        <template #cell(manage)="row">
          <b-button
            variant="outline-primary"
            pill
            size="sm"
            class="mr-50"
            @click="editBuilding(row.item)"
            v-if="hasPermission('update_building')"
          >
            Edit Building
          </b-button>
          
          
          <b-button
            variant="primary"
            pill
            size="sm"
            class="mr-50"
            @click="viewFloor(row.item)"
            v-if="hasPermission('read_floor')"
          >
            View Floors
          </b-button>

          <b-button
            variant="primary"
            pill
            size="sm"
            class="mr-50"
            @click="viewFlat(row.item)"
            v-if="hasPermission('read_flat')"
          >
            View Units
          </b-button>
          
        </template>
      </b-table>
      <div class="row">
        <div class="col-md-11">
          <b-pagination
            size="md"
            :total-rows="totalItems"
            v-model="currentPage"
            :per-page="perPage"
          ></b-pagination>
        </div>
        <div class="col-md-1">
          <h4>
          Total: {{ totalItems }} 
          </h4>
        </div>
      </div>
    </b-card>
    <CreateBuildingModal
      @modalClosed="onModalClosed"
      :key="`create-${createBuildingModalCount}`"
    />
    <EditBuildingModal
      :building="building"
      @modalClosed="onModalClosed"
      :key="`edit-${editBuildingModalCount}`"
    />
    <CreateFloorModal
      :building="building"
      @modalClosed="onModalClosed"
      :key="`createfloor-${createFloorModalCount}`"
    />
    <CreateFlatModal
      :building="building"
      @modalClosed="onModalClosed"
      :key="`createflat-${createFlatModalCount}`"
    />
    <ViewFloorModal
      :building="building"
      @createFloor="createFloor"
      :key="`viewfloor-${viewFloorModalCount}`"
    />
    <ViewFlatModal
      :building="building"
      @createFlat="createFlat"
      :key="`viewflat-${viewFlatModalCount}`"
    />
    
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueSelectPaginated from "@/components/ui/VueSelectPaginated.vue";
import CreateBuildingModal from "@/components/building/CreateBuildingModal.vue";
import EditBuildingModal from "@/components/building/EditBuildingModal.vue";
import CreateFloorModal from "@/components/building/CreateFloorModal.vue";
import CreateFlatModal from "@/components/building/CreateFlatModal.vue";
import ViewFloorModal from "@/components/building/ViewFloorModal.vue";
import ViewFlatModal from "@/components/building/ViewFlatModal.vue";
import util from "@/util.js";
import VueGauge from 'vue-gauge';


export default {
  components: {
    CreateBuildingModal,
    EditBuildingModal,
    CreateFloorModal,
    CreateFlatModal,
    ViewFloorModal,
    ViewFlatModal,
    VueSelectPaginated,
    VueGauge,
  },
  data() {
    return {
      fields: [
        { key: "name", label: "Name" },
        { key: "building_type", label: "Building Type" },
        { key: "total_residents_count", label: "Residents" },
        { key: "total_peeps_count", label: "Total Peeps" },
        { key: "total_floors_count", label: "Total Floors" },
        { key: "total_flats_count", label: "Units" },
        { key: "site_data", label: "Site" },
        { key: "ase_number", label: "ASE #" },
        
        { key: "manage", label: "Actions" },
      ],
      currentPage: 1,
      perPage: 0,
      totalItems: 0,
      buildings: [],
      building: {},
      createBuildingModalCount: 0,
      editBuildingModalCount: 0,
      createFloorModalCount: 0,
      createFlatModalCount: 0,
      viewFloorModalCount: 0,
      viewFlatModalCount: 0, 
      searchTypes: [
        { value: 1, name: "Site" },
        { value: 2, name: "Building Type" },
      ],
      searchType: null,
      name: "",
      counts : "",
      site : "",
      sites : [],
      building_type : "",
      building_types : [
        { value: "Apartment", name: "Apartment" },
        { value: "Town House", name: "Town House" },
      ],
    };
  },
  mixins: [util],
  created() {
    this.searchType = this.searchTypes[0];
  },
  async mounted() {
    await this.fetchPaginatedData();
    const counter = await this.getCounter();
    this.counts = counter.data;
    
    const sites = await this.getSitesDDL();
    this.sites = sites.data;
  },
  methods: {
    ...mapActions({
      getCounter: "appData/getCounter",
      getBuildings: "appData/getBuildings",
      getSitesDDL: "appData/getSitesDDL",
    }),
    async search() {
      if (this.searchType) {
        switch (this.searchType.value) {
          case 1:
            this.building_type = "";
            break;
          case 2:
            this.site = "";
            break;        }
      } else {
        this.site = "";
        this.building_type = "";
      }
      this.currentPage = 1;
      await this.fetchPaginatedData();
    },
    async fetchPaginatedData() {
      try {
        const res = await this.getBuildings({
          pageNumber: this.currentPage,      
          site: this.site,      
          building_type: this.building_type,      
        });
        this.buildings = res.data.results;
        this.totalItems = res.data.count;
        this.perPage = res.data.per_page;
      } catch (error) {
        this.displayError(error);
      }
    },
    createBuilding() {
      this.createBuildingModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("create-building-modal");
      });
    },
    editBuilding(building) {
      this.building = building;
      this.editBuildingModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("edit-building-modal");
      });
    },
    createFloor(building) {
      this.building = building;
      this.createFloorModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("create-floor-modal");
      });
    },

    createFlat(building) {
      this.building = building;
      this.createFlatModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("create-flat-modal");
      });
    },

    viewFloor(building) {
      this.building = building;
      this.viewFloorModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("view-floor-modal");
      });
    },

    viewFlat(building) {
      this.building = building;
      this.viewFlatModalCount += 1;
      this.$nextTick(() => {
        this.$bvModal.show("view-flat-modal");
      });
    },

    

    async removeBuilding(building) {
      this.building = building;
      try {
        const res = await this.deleteBuilding({
          pk: this.building.id,
        });
        if (res.status === 204) {
          this.$swal({
            title: "Building deleted successfully",
            icon: "success",
          });
          if (
            (this.totalItems - 1) % this.perPage === 0 &&
            this.currentPage !== 1
          ) {
            this.currentPage -= 1;
          } else {
            await this.fetchPaginatedData();
          }
        }
      } catch (error) {
        this.displayError(error);
      }
    },
    async onModalClosed() {
      await this.fetchPaginatedData();
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "appData/hasPermission",
    }),
  },
  watch: {
    currentPage: async function (val) {
      await this.fetchPaginatedData();
    },
  },
};
</script>

<style></style>
